import BigNumber from 'bignumber.js'
import { numberMoney } from 'Data/format.js'

export function getValue(charges) {
  let total = charges.reduce(
    (acc, charge) => acc.plus(charge.amount),
    BigNumber(0)
  )
  return numberMoney(total)
}
